import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../Redux/Actions/actions";
import { BaseUrlReports } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Button from "@mui/material/Button";
import { Spinner } from "react-bootstrap";
import { TiWarningOutline } from "react-icons/ti";
import { DownloadSimple } from "@phosphor-icons/react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};
const Agentlogin = (props) => {
  const selectAgentRef = useRef(null);
  const selectSkillsetRef = useRef(null);
  const selectDispositionRef = useRef(null);

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const animatedComponents = makeAnimated();
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [calldetailsreportlist, setCalldetailsreportlist] = useState({});
  const [agentlistdata, setAgentlistdata] = useState([]);
  const [skillsetdata, setSkillsetdata] = useState([]);
  const [disposition, setDisposition] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [agentspinner, setagentspinner] = useState(false);

  const [agentlogindatalist, setAgentLoginDataList] = useState([]);

  const [selectedagent, setSelectedagent] = useState("");

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const optionsAgent = agentlistdata.map((agent) => ({
    value: agent.agent_id,
    label: agent.agent_name,
  }));

  // const optionsAgent = agentlistdata.map((option)=>{
  //     console.log(option)
  // })
  const optionsSkillset = skillsetdata.map((skillset) => ({
    value: skillset,
    label: skillset,
  }));

  const optionsDisposition = disposition.map((dispos) => ({
    value: dispos,
    label: dispos,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (!apiCallsMade) {
      agentCallDetailsReportDataAgentList();
      setApiCallsMade(true);
    }
  }, [apiCallsMade]);

  useEffect(() => {
    agentLogindatalist();
  }, [page]);

  const agentLogindatalist = async () => {
    setApiCallsMade(true);
    setagentspinner(true);
    await axios
      .post(
        BaseUrlReports + "api/agent_login",
        {
          start_date: fromdate,
          end_date: todate,
          agent_id: selectedagent,
          tenent_id: localStorage.getItem("TenantId"),
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setagentspinner(false);
          console.log(res.data.callsCountPerAgentPerDate);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.count);
        }
      })

      .catch((error) => {
        setAgentLoginDataList([])
        setagentspinner(false);
        console.log(error);
      });
  };

  const handleChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const agentCallDetailsReportDataAgentList = async () => {
    setApiCallsMade(true);
    await axios
      .post(
        BaseUrlReports + "api/agents",
        {
          tenent_id: localStorage.getItem("TenantId"),
          // tenent_id:"a3dc14bd-fe70-4120-8572-461b0dc866b5"
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setAgentlistdata(res.data.agents);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelectAgentChange = (selectedOptions) => {
    const value = selectedOptions.map((option) => option.value);
    setSelectedagent(value);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setTodate("");
    setFromdate("");
    handelCloseFilter();
  };

  return (
    <>
      <div
        className={
          showfilter
            ? "offcanvas offcanvas-end show"
            : "offcanvas offcanvas-end"
        }
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            Filter
          </h5>
          <button
            onClick={handelCloseFilter}
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="mb-3">
            <label for="exampleInputfromdate" className="form-label">
              From Date <small className="text-danger">*</small>
            </label>
            <input
              type="date"
              value={fromdate}
              onChange={(e) => {
                setFromdate(e.target.value);
              }}
              className="form-control form-control-lg"
              id="exampleInputfromdate"
            />
          </div>
          <div className="mb-3">
            <label for="exampleInputtodate" className="form-label">
              To Date <small className="text-danger">*</small>
            </label>
            <input
              value={todate}
              type="date"
              onChange={(e) => {
                setTodate(e.target.value);
              }}
              className="form-control form-control-lg"
              id="exampleInputtodate"
            />
          </div>

          <div className="mb-3">
            <label for="exampleInputfromdate" className="form-label">
              Agent <small className="text-danger">*</small>
            </label>
            <Select
              ref={selectAgentRef}
              closeMenuOnSelect={true}
              components={animatedComponents}
              isMulti
              options={optionsAgent}
              placeholder="Select Agent"
              styles={customStyles}
              onChange={handleSelectAgentChange}
            />
          </div>
        </div>
        {/* <div className="offcanvas-sub-btn mb-1 d-flex justify-content-between ">
                    <button onClick={handelCloseFilter} type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                        className="btn btn-secondary btn-sm mx-1">Close</button>
                    <button onClick={resetButton} type="button" className="btn btn-warning btn-sm flex-fill mx-1" >Reset</button>
                    <button onClick={() => { agentLogindatalist(); handelCloseFilter() }} type="button" className="mx-1 btn btn-primary btn-sm flex-fill">Submit</button>
                </div> */}

        <div className="offcanvas-sub-btn d-flex justify-content-between mb-1">
          <button
            onClick={handelCloseFilter}
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            className="btn btn-secondary btn-sm mx-1 flex-fill"
          >
            Close
          </button>
          <button
            onClick={resetButton}
            type="button"
            className="btn btn-sm btn-warning mx-1  flex-fill"
          >
            Reset
          </button>
          <button
            onClick={() => {
              setPage(1);
              agentLogindatalist();
              handelCloseFilter();
            }}
            type="button"
            className=" mx-1 btn-sm btn btn-primary flex-fill"
          >
            Submit
          </button>
        </div>
      </div>

      <div className="sub-wapper bg-light" id="mainid">
        <div className="container-fluid">
          <div
            className="sub-main card border-0 rounded-0"
            id="menu1"
            style={{ height: "98vh" }}
          >
            <div className="card-header rounded-0 shadow-sm border-0 bg-white d-flex justify-content-between align-content-center">
              <span className="fw-bold">Agent Login Reports</span>
              <div>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ marginRight: "2px" }}
                  type="button"
                  endIcon={<DownloadSimple size={18} weight="bold" />}
                >
                  Download Report
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ marginRight: "2px" }}
                  onClick={handelShowFilter}
                  type="button"
                >
                  <FilterListIcon className="me-1" />
                  Filter
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  type="button"
                  onClick={() => {
                    props.setSelectedMenu("ReportMenu");
                  }}
                >
                  <KeyboardBackspaceIcon className="me-1" />
                  Back
                </Button>
              </div>
            </div>

            <div className="container-fluid" style={{ paddingLeft: "1px" }}>
              <div className="container-fluid p-2">
                <div className="card fixed-table-card vh-79 ">
                  <div
                    className="card-body agentContactbody"
                    style={{
                      minWidth: "100%",
                      overflowX: "auto",
                      overflowY: "clip",
                    }}
                  >
                    <div
                      className="table-responsive vhm-68"
                      style={{ width: "", overflowX: "auto" }}
                    >
                      <table className="table table-sm  table-hover align-middle table-fixeded">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Agent Name</th>
                            <th scope="col">Login Time</th>
                            <th scope="col">Logout Time</th>
                            <th scope="col">Total Time</th>
                          </tr>
                        </thead>

                        <tbody>
                          {agentlogindatalist &&
                          agentlogindatalist.length > 0 ? (
                            agentlogindatalist.map((item) => {
                              return (
                                <tr>
                                  <td>{item.date}</td>
                                  <td>
                                    {item.agent_name ? item.agent_name : "--"}
                                  </td>
                                  <td>
                                    {moment(item.login_time).format("llll")}
                                  </td>
                                  <td>
                                    {moment(item.logout_time).format("llll")}
                                  </td>
                                  <td>{item.total_time}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <div
                              className="d-flex justify-content-center align-items-center position-absolute"
                              style={{ minHeight: "400px", left: "50%" }}
                            >
                              <div
                                className="d-flex"
                                style={{ flexDirection: "column" }}
                              >
                                {agentspinner ? (
                                  <>
                                    <Spinner
                                      animation="border"
                                      variant="primary"
                                    />
                                    <span
                                      className="position-relative mt-2"
                                      style={{ left: "-10px" }}
                                    >
                                      Loading...
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <TiWarningOutline
                                      size={30}
                                      className="mx-auto text-muted"
                                    />
                                    <span className="fw-bold text-muted">
                                      No Data Found
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer rounded-0 d-flex justify-content-between">
                    <div>
                      {/* Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                        {Math.min(page * 10, pagination)} of {pagination} entries */}
                      Showing{" "}
                      {Math.min(
                        (page - 1) * 10 + 1,
                        isNaN(pagination) ? 0 : pagination
                      )}{" "}
                      to{" "}
                      {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)}{" "}
                      of {isNaN(pagination) ? 0 : pagination} entries
                    </div>
                    <Pagination
                      count={Math.ceil(pagination / 10)}
                      page={page}
                      color="primary"
                      size="small"
                      style={{ float: "right" }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(Agentlogin);
